import "../components/styles/MainPage.css";
import "../components/styles/Onboarding.css"
import {useNavigate} from "react-router-dom";
import React from "react";

// 스와이퍼 슬라이드
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';


const MainPage = () => {
    const navigate = useNavigate();
    const [products, setProducts] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [isItemLoading, setIsItemLoading] = React.useState(true);

    // 새로 접속 시 맨 위로 이동
    window.scrollTo(0, 0);

    // 페이지 로딩 시 상품 데이터를 받아옴
    React.useEffect(() => {
        const getProductList = async () => {
            setIsItemLoading(true);

            const response = await fetch("/api/items", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (response.ok) {
                // console.log('아이템리스트 : ', data);

                // category에 따라 4개씩 나누기
                const bestItems = data.items.filter(item => item.category === 'BEST').slice(0, 4);
                const newItems = data.items.filter(item => item.category === 'NEW').slice(0, 4);
                const discountedItems = data.items.filter(item => item.category === 'DISCOUNTED').slice(0, 4);

                // 필요한 데이터 구조로 저장
                setProducts({
                    best: bestItems,
                    new: newItems,
                    discounted: discountedItems,
                });

                setLoading(false);
                setIsItemLoading(false);
            } else {
                const errorData = await response.json();
                setError(errorData.message || "상품 데이터 불러오기에 실패했습니다.");
                setLoading(false);
                setIsItemLoading(false);
                // console.log(errorData.message || "상품 데이터 불러오기에 실패했습니다.");
            }
        };

        getProductList();
    }, []);

    const getProductDetail = (itemId) => {
        navigate(`/products/${itemId}`);

        // 스크롤 맨 위로 이동
        window.scrollTo(0, 0);
    };

    // 카테고리 클릭 시 해당 카테고리로 이동
    function handleCategoryBest() {
        navigate(`/products`, { state: "BEST" });
    }


    function handleCategoryNew()  {
        navigate(`/products`, { state: "NEW" });
    }

    function handleCategoryDiscounted() {
        navigate(`/products`, { state: "DISCOUNTED" });
    }

    function handleCategoryNComapny() {
        navigate(`/products`, { state: "NCOMPANY" });
    }

    function handleCategoryKCompany() {
        navigate(`/products`, { state: "KCOMPANY" });
    }

    function handleCategoryEtc() {
        navigate(`/products`, { state: "ETC" });
    }

    const formatPrice = (price) => price?.toLocaleString() || "0";

    return (
        <div>
            <div className="flex flex-col min-h-screen bg-white ">
                <main className="">
                    <div className="main-content">
                        {/*/!* Hero Section *!/*/}
                        {/*<section className="relative h-screen max-h-[800px] mt-[160px] w-full bg-black rounded-full ">*/}
                        {/*    /!* Glow Effect *!/*/}
                        {/*    <div className="hero-glow"></div>*/}
                        {/*    /!* 배경 이미지 *!/*/}
                        {/*    <div*/}
                        {/*        className="absolute inset-0 bg-cover bg-center bg-no-repeat"*/}
                        {/*        style={{backgroundImage: "url('/images/main_hero_image.png')"}}*/}
                        {/*    ></div>*/}

                        {/*    /!* 오버레이 (배경 어둡게 처리) *!/*/}
                        {/*    /!*<div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/90"></div>*!/*/}

                        {/*    /!* 텍스트 콘텐츠 *!/*/}
                        {/*    <div*/}
                        {/*        className="relative z-10 flex h-full items-center lg:justify-end md:justify-center sm:justify-center justify-center text-center px-6">*/}
                        {/*        <div className="max-w-2xl text-white">*/}
                        {/*            <h1 className="text-4xl font-bold leading-tight mr-5 md:text-5xl lg:text-6xl">*/}
                        {/*                자동화 소프트웨어<br/>*/}
                        {/*                프로그램을 간편하게<br/>*/}
                        {/*                다운로드해 보세요!*/}
                        {/*            </h1>*/}
                        {/*            /!*<p className="mt-6 text-lg md:text-xl text-gray-300">*/}
                        {/*            업무의 효율성을 높이는 완벽한 자동화 솔루션, 지금 바로 시작하세요.*/}
                        {/*        </p>*!/*/}
                        {/*            <a*/}
                        {/*                href="/products"*/}
                        {/*                className="inline-block mt-8 rounded-full bg-white px-8 py-4 text-lg font-semibold text-purple-900 transition-all hover:bg-purple-200"*/}
                        {/*            >*/}
                        {/*                더보기*/}
                        {/*                <svg*/}
                        {/*                    className="ml-2 inline-block h-5 w-5"*/}
                        {/*                    fill="none"*/}
                        {/*                    stroke="currentColor"*/}
                        {/*                    viewBox="0 0 24 24"*/}
                        {/*                >*/}
                        {/*                    <path*/}
                        {/*                        strokeLinecap="round"*/}
                        {/*                        strokeLinejoin="round"*/}
                        {/*                        strokeWidth={2}*/}
                        {/*                        d="M9 5l7 7-7 7"*/}
                        {/*                    />*/}
                        {/*                </svg>*/}
                        {/*            </a>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</section>*/}

                        <section className="hero-section">
                            <button onClick={() => navigate("/products")}>
                                <img src="/images/main_hero_image2.png" alt=""/>
                            </button>
                        </section>

                        {/* Categories Section */}
                        <section className="categories-section">
                            <h1 className="category-title">상품</h1>
                            <div className="category-content">
                                <div className="category" role="button" onClick={handleCategoryBest}>
                                    {/*<img className="icon-best" src="/images/icon/main_thumb.png" alt="베스트"></img>*/}
                                    <svg className="icon-best" xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                         viewBox="0 0 46 46"
                                         fill="none">
                                        <path
                                            d="M2.57087 18.5709H9.42801V45.9996H2.57087C1.30852 45.9996 0.285156 44.9763 0.285156 43.7139V20.8567C0.285156 19.5943 1.30852 18.5709 2.57087 18.5709ZM14.6689 15.6158L29.2986 0.986117C29.7007 0.583946 30.3375 0.538711 30.7924 0.879946L32.7412 2.34152C33.849 3.17243 34.3482 4.58822 34.0065 5.93023L31.3704 16.2852H45.9994C48.5242 16.2852 50.5709 18.3319 50.5709 20.8567V25.6665C50.5709 26.2638 50.4538 26.8551 50.2266 27.4071L43.1537 44.584C42.801 45.4405 41.9663 45.9996 41.0401 45.9996H16.2852C15.0228 45.9996 13.9994 44.9763 13.9994 43.7139V17.232C13.9994 16.6258 14.2403 16.0444 14.6689 15.6158Z"
                                            fill="#3954DE"/>
                                    </svg>
                                    <span>베스트</span>
                                </div>
                                <div className="category" role="button" onClick={handleCategoryNew}>
                                    {/*<img className="icon-new" src="/images/icon/main_new.png" alt="신상품"></img>*/}
                                    <svg className="icon-best" xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                         viewBox="0 0 41 36"
                                         fill="none">
                                        <path
                                            d="M40.0118 14V34C40.0118 35.1046 39.1164 36 38.0118 36H2.01172C0.907159 36 0.0117188 35.1046 0.0117188 34V14H40.0118ZM40.0118 10H0.0117188V2C0.0117188 0.89542 0.907159 0 2.01172 0H38.0118C39.1164 0 40.0118 0.89542 40.0118 2V10ZM26.0118 26V30H34.0118V26H26.0118Z"
                                            fill="#3954DE"/>
                                    </svg>
                                    <span>신상품</span>
                                </div>
                                <div className="category" role="button" onClick={handleCategoryDiscounted}>
                                    {/*<img className="icon-discount" src="/images/icon/main_discount.png"*/}
                                    {/*     alt="할인상품"></img>*/}
                                    <svg className="icon-best" xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                                         viewBox="0 0 48 48"
                                         fill="none">
                                        <path
                                            d="M27.8941 4.18919C25.6515 2.27807 22.3532 2.27809 20.1108 4.18917L17.4147 6.48669C17.0943 6.75967 16.6961 6.92463 16.2765 6.95811L12.7456 7.23989C9.80849 7.47427 7.47623 9.80654 7.24185 12.7436L6.96009 16.2745C6.92663 16.6941 6.76161 17.0924 6.48863 17.4128L4.19111 20.1088C2.28003 22.3514 2.28005 25.6496 4.19115 27.892L6.48867 30.5882C6.76161 30.9086 6.92659 31.3068 6.96007 31.7264L7.24189 35.2572C7.47627 38.1942 9.80855 40.5264 12.7456 40.7608L16.2765 41.0428C16.6961 41.0762 17.0943 41.2412 17.4146 41.5142L20.1105 43.8116C22.3531 45.7226 25.6515 45.7228 27.8941 43.8116L30.5901 41.5142C30.9103 41.2412 31.3085 41.0762 31.7281 41.0426L35.2591 40.7608C38.1961 40.5266 40.5284 38.1944 40.763 35.2572L41.0445 31.7264C41.0779 31.3068 41.2431 30.9084 41.5159 30.588L43.8135 27.8922C45.7247 25.6496 45.7247 22.3512 43.8135 20.1088L41.5159 17.4127C41.2429 17.0923 41.0782 16.6941 41.0448 16.2746L40.763 12.7436C40.5286 9.80658 38.1961 7.47423 35.2591 7.23987L31.7281 6.95809C31.3085 6.92461 30.9103 6.75967 30.5901 6.48669L27.8941 4.18919ZM29.6587 15.5153L32.4871 18.3438L18.345 32.486L15.5166 29.6574L29.6587 15.5153ZM20.4663 20.465C19.2947 21.6366 17.3952 21.6366 16.2237 20.465C15.0521 19.2936 15.0521 17.394 16.2237 16.2224C17.3952 15.0509 19.2947 15.0509 20.4663 16.2224C21.6379 17.394 21.6379 19.2936 20.4663 20.465ZM27.5373 31.7788C26.3657 30.6072 26.3657 28.7078 27.5373 27.5362C28.7089 26.3646 30.6083 26.3646 31.7799 27.5362C32.9515 28.7078 32.9515 30.6072 31.7799 31.7788C30.6083 32.9504 28.7089 32.9504 27.5373 31.7788Z"
                                            fill="#3954DE"/>
                                    </svg>
                                    <span>할인상품</span>
                                </div>
                                <div className="category" role="button" onClick={handleCategoryNComapny}>
                                    {/*<img className="icon-n" src="/images/icon/main_ncompany.png" alt="N사"></img>*/}
                                    <svg className="icon-best" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                                         viewBox="0 0 48 49"
                                         fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M17.1451 24.7816V43.3639H6.85938V3.93534H17.1439L17.1528 3.92871L28.9766 19.9652L30.8594 22.5189V3.93534H41.1451V43.3639H30.8594V43.3312L30.835 43.3492L17.1451 24.7816Z"
                                              fill="#3954DE"/>
                                    </svg>
                                    <span>N사</span>
                                </div>
                                <div className="category" role="button" onClick={handleCategoryKCompany}>
                                    {/*<img className="icon-k" src="/images/icon/main_kcompany.png" alt="K사"></img>*/}
                                    <svg className="icon-best" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                                         viewBox="0 0 40 48"
                                         fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M26.2659 5.98365L38.9989 5.9834L23.7801 22.5248L38.5 42.8643H27.0574L17.0012 29.8929L17 29.8942V43.0001H7V6.00008H17V15.5718L26.2659 5.98365Z"
                                              fill="#3954DE"/>
                                    </svg>
                                    <span>K사</span>
                                </div>
                                <div className="category" role="button" onClick={handleCategoryEtc}>
                                    {/*<img className="icon-etc" src="/images/icon/main_etc.png" alt="기타"></img>*/}
                                    <svg className="icon-best" xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                                         viewBox="0 0 48 49"
                                         fill="none">
                                        <path
                                            d="M28 36.5V40.5L32 42.5V44.5H16L15.9928 42.5072L20 40.5V36.5H5.9836C4.8881 36.5 4 35.6022 4 34.485V8.51496C4 7.40214 4.91062 6.5 5.9836 6.5H42.0164C43.112 6.5 44 7.39784 44 8.51496V34.485C44 35.5978 43.0894 36.5 42.0164 36.5H28ZM8 28.5V32.5H40V28.5H8Z"
                                            fill="#3954DE"/>
                                    </svg>
                                    <span role="button" onClick={() => navigate("/products")}>기타</span>
                                </div>
                            </div>
                        </section>

                        <section className="featured-section">
                            <div className="featured-title-section">
                                <small className="featured-subtitle">맞춤형 소프트웨어</small>
                                <h2 className="featured-title">당신만의 맞춤형 소프트웨어 솔루션,</h2>
                                <h2 className="featured-title">지금 시작하세요</h2>
                                <button className="apply-button" onClick={() => {navigate('/custom-product-first')}}>신청하기</button>
                            </div>

                            {/* 무한 슬라이드 리뷰 */}
                            <Swiper
                                slidesPerView="auto"        // 자동으로 슬라이드 개수 조정
                                breakpoints={{
                                    // 화면 너비가 320px 이상일 때
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 20
                                    },
                                    // 화면 너비가 480px 이상일 때
                                    480: {
                                        slidesPerView: 1,
                                        spaceBetween: 30
                                    },
                                    // 화면 너비가 640px 이상일 때
                                    640: {
                                        slidesPerView: 2,
                                        spaceBetween: 30
                                    },
                                    // 화면 너비가 992px 이상일 때
                                    992: {
                                        slidesPerView: 3,
                                        spaceBetween: 50
                                    }
                                }}
                                spaceBetween={50}           // 카드 사이 간격
                                loop={true}                 // 무한 루프
                                speed={9000}                // 슬라이드 속도 (4초에 한 번 슬라이드)
                                autoplay={{
                                    delay: 0,               // 지연 없이 바로 시작
                                    disableOnInteraction: false,
                                }}
                                modules={[Autoplay]}
                                className="reviews-swiper"
                            >
                                <SwiperSlide>
                                    <div className="review-card">
                                        <div className="reviewer-info">
                                            <div className="reviewer-avatar"></div>
                                            <div className="reviewer-details">
                                                <p className="reviewer-product-name">네이버 자동 추출기</p>
                                                <span className="reviewer-name">닉네임</span><span className="review-date">2024.05.20</span>
                                            </div>
                                        </div>
                                        <div className="rating">
                                            <span className="star">★</span>
                                            <span className="star-text">4.5</span>
                                        </div>
                                        <p className="review-text">
                                            간편하고 빠른 데이터 추출이 가능하다는 점이 큰 장점입니다. 업무 효율이 크게 향상되었습니다.
                                        </p>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="review-card">
                                        <div className="reviewer-info">
                                            <div className="reviewer-avatar"></div>
                                            <div className="reviewer-details">
                                                <p className="reviewer-product-name">소프트웨어 A</p>
                                                <span className="reviewer-name">고객2</span><span className="review-date">2024.05.19</span>
                                            </div>
                                        </div>
                                        <div className="rating">
                                            <span className="star">★</span>
                                            <span className="star-text">4.7</span>
                                        </div>
                                        <p className="review-text">
                                            다양한 기능이 포함되어 있어서 정말 만족합니다. 설치도 간편하고 빠르네요.
                                        </p>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="review-card">
                                        <div className="reviewer-info">
                                            <div className="reviewer-avatar"></div>
                                            <div className="reviewer-details">
                                                <p className="reviewer-product-name">자동화 솔루션</p>
                                                <span className="reviewer-name">사용자3</span><span className="review-date">2024.05.18</span>
                                            </div>
                                        </div>
                                        <div className="rating">
                                            <span className="star">★</span>
                                            <span className="star-text">5.0</span>
                                        </div>
                                        <p className="review-text">
                                            지금까지 사용한 자동화 소프트웨어 중 최고! 지원도 빠르고 만족스럽습니다.
                                        </p>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="review-card">
                                        <div className="reviewer-info">
                                            <div className="reviewer-avatar"></div>
                                            <div className="reviewer-details">
                                                <p className="reviewer-product-name">자동화 솔루션</p>
                                                <span className="reviewer-name">사용자3</span><span className="review-date">2024.05.18</span>
                                            </div>
                                        </div>
                                        <div className="rating">
                                            <span className="star">★</span>
                                            <span className="star-text">5.0</span>
                                        </div>
                                        <p className="review-text">
                                            지금까지 사용한 자동화 소프트웨어 중 최고! 지원도 빠르고 만족스럽습니다.
                                        </p>
                                    </div>
                                </SwiperSlide>
                                {/* 필요할 만큼 추가 가능 */}
                            </Swiper>
                        </section>

                        {/* 2025-01-10 TODO: 아이템 썸네일 등록 후 이미지 불러오기 */}
                        {/* Best Sellers Section */}
                        <section className="best-sellers-section">
                            <h2 className="category-title">| 베스트 상품</h2>
                            {/*// 상품이 존재할 경우 표시*/}
                            {!isItemLoading && (
                                <div className="product-grid">
                                    {products.best.map((product, index) => (
                                        <div key={index} className="product-card relative" role="button" onClick={() => getProductDetail(product.itemId)}>
                                            {product.category === 'DISCOUNTED' && (
                                                <div className="discount-badge absolute top-3 left-3 bg-red-500 text-white px-3 py-1 rounded-full shadow-md text-sm font-semibold z-10 animate-pulse">
                                                    할인상품
                                                </div>
                                            )}
                                            <div className="product-image">
                                                {product.thumbFileName && product.thumbPath ? (
                                                    <img src={product.thumbPath || "/placeholder.svg"} alt={product.itemName} className="w-full h-full object-cover rounded-xl" />
                                                ) : (
                                                    <div className="w-full h-full bg-gray-200 flex items-center justify-center rounded-xl">
                                                        <span className="text-gray-400">No Image</span>
                                                    </div>
                                                )}
                                            </div>
                                            <h2 className="product-title mt-2 font-semibold text-lg">{product.itemName}</h2>
                                            <p className="product-description text-gray-600 text-sm">{product.itemDescription}</p>
                                            <p id="product-original-price" className="line-through text-gray-400">{formatPrice(product.costPrice)}원</p>
                                            <div className="product-price-grid-main flex items-center justify-between mt-1">
                                                <p className="product-discount-rate text-red-500 font-bold">{product.discountRate}%</p>
                                                <p className="product-price text-xl font-bold text-gray-800">{formatPrice(product.salePrice)}원</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </section>

                        {/* New Products Section */}
                        <section className="new-products-section">
                            <h2 className="category-title">| 신상품</h2>
                            {!isItemLoading && (
                                <div className="product-grid">
                                    {products.new.map((product, index) => (
                                        <div key={index} className="product-card relative" role="button" onClick={() => getProductDetail(product.itemId)}>
                                            {product.category === 'DISCOUNTED' && (
                                                <div className="discount-badge absolute top-3 left-3 bg-red-500 text-white px-3 py-1 rounded-full shadow-md text-sm font-semibold z-10 animate-pulse">
                                                    할인상품
                                                </div>
                                            )}
                                            <div className="product-image">
                                                {product.thumbFileName && product.thumbPath ? (
                                                    <img src={product.thumbPath || "/placeholder.svg"} alt={product.itemName} className="w-full h-full object-cover rounded-xl" />
                                                ) : (
                                                    <div className="w-full h-full bg-gray-200 flex items-center justify-center rounded-xl">
                                                        <span className="text-gray-400">No Image</span>
                                                    </div>
                                                )}
                                            </div>
                                            <h2 className="product-title mt-2 font-semibold text-lg">{product.itemName}</h2>
                                            <p className="product-description text-gray-600 text-sm">{product.itemDescription}</p>
                                            <p id="product-original-price" className="line-through text-gray-400">{formatPrice(product.costPrice)}원</p>
                                            <div className="product-price-grid-main flex items-center justify-between mt-1">
                                                <p className="product-discount-rate text-red-500 font-bold">{product.discountRate}%</p>
                                                <p className="product-price text-xl font-bold text-gray-800">{formatPrice(product.salePrice)}원</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </section>

                        {/* Promotional Section */}
                        <section className="sale-products-section">
                            <h2 className="category-title">| 할인 상품</h2>
                            {!isItemLoading && (
                                <div className="product-grid">
                                    {products.discounted.map((product, index) => (
                                        <div key={index} className="product-card relative" role="button" onClick={() => getProductDetail(product.itemId)}>
                                            {product.category === 'DISCOUNTED' && (
                                                <div className="discount-badge absolute top-3 left-3 bg-red-500 text-white px-3 py-1 rounded-full shadow-md text-sm font-semibold z-10 animate-pulse">
                                                    할인상품
                                                </div>
                                            )}
                                            <div className="product-image">
                                                {product.thumbFileName && product.thumbPath ? (
                                                    <img src={product.thumbPath || "/placeholder.svg"} alt={product.itemName} className="w-full h-full object-cover rounded-xl" />
                                                ) : (
                                                    <div className="w-full h-full bg-gray-200 flex items-center justify-center rounded-xl">
                                                        <span className="text-gray-400">No Image</span>
                                                    </div>
                                                )}
                                            </div>
                                            <h2 className="product-title mt-2 font-semibold text-lg">{product.itemName}</h2>
                                            <p className="product-description text-gray-600 text-sm">{product.itemDescription}</p>
                                            <p id="product-original-price" className="line-through text-gray-400">{formatPrice(product.costPrice)}원</p>
                                            <div className="product-price-grid-main flex items-center justify-between mt-1">
                                                <p className="product-discount-rate text-red-500 font-bold">{product.discountRate}%</p>
                                                <p className="product-price text-xl font-bold text-gray-800">{formatPrice(product.salePrice)}원</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </section>

                        {/*    동영상 매뉴얼 섹션 */}
                        <section className="video-manual-section">
                            <div className="onboarding-card">
                                <div className="left-section">
                                    {/*<div className="title-container">*/}
                                    {/*    <h2 className="subtitle">테마 이해하기</h2>*/}
                                    {/*    <h1 className="title">협업</h1>*/}
                                    {/*</div>*/}

                                    <div className="image-container">
                                        <img
                                            src="/images/video_img.png"
                                            alt="Software Interface Preview"
                                            className="preview-image"
                                        />
                                    </div>
                                </div>

                                <div className="right-section">
                                    <div className="content-container">
                                        <h2 className="content-title">처음이라도 걱정 마세요.</h2>
                                        <p className="content-description">
                                            동영상 매뉴얼을 통해
                                            <br/>
                                            쉽게 이해하고 사용할 수 있어요.
                                        </p>
                                    </div>
                                    <div className="button-section">
                                        <button className="manual-button"
                                                onClick={() => navigate('/manual')}>
                                            매뉴얼 보러가기 →
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* 배너광고 섹션 */}
                        <section className="banner-ad">
                            <div className="banner-container">
                                <div className="banner-text">
                                    <h2>지금 특별 할인 중!</h2>
                                    <p>한정된 시간 동안만 제공되는 할인 혜택을 놓치지 마세요.</p>
                                </div>
                                <a href="https://your-ad-link.com" target="_blank" rel="noopener noreferrer">
                                    {/*<img src="https://via.placeholder.com/300x100" alt="광고 배너" className="banner-image" />*/}
                                </a>
                            </div>
                        </section>

                        {/* 회사소개 섹션 */}
                        <section className="intro-company">
                            <div className="intro-banner">
                                <div className="intro-content">
                                    <h2 className="intro-content-1">소프트캣의 첫 발걸음과 성장스토리를 확인하세요</h2>
                                    <button onClick={() => navigate("/about")} className="check-button">
                                        확인하러가기
                                    </button>
                                </div>
                            </div>
                        </section>

                        {/* ✅ 카카오톡 상담 아이콘 */}
                        <div className="chat-floating-wrapper">
                            <div className="chat-bubble">카카오톡 문의하기 ></div>
                            <div className="chat-floating-button" onClick={() => window.open('http://pf.kakao.com/_xkVeGn', '_blank')}>
                                <img src="/images/kakako_icon.png" alt="상담하기" />
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MainPage;
